import Image from "next/image";
import Link from "next/link";
import { RecommendedAuthorsProps } from "@/types/modules/author/components";
import React, { useEffect, useState } from "react";
import { DottedSeparator } from "@/components/ui-kit/Decorations/DottedSeparator";
import useSettingsProvider from "@/core/dataProviders/providers/app/useSettingsProvider";
import { ImageWithSkeleton } from "@/components/ui-kit/ImageWithSkeleton";
import { useOfflineImageContent } from "@/hooks/indexeddb/useOfflineImageContent";

export const RecommendedAuthors: React.FC<RecommendedAuthorsProps> = ({ author }) => {
  const [settings, settingsReqState] = useSettingsProvider();
  const [offlineThumbnailBlob, setOfflineThumbnailBlob] = useState<string>();
  const { loadOfflineImage } = useOfflineImageContent();
  const [hoveredAuthor, setHoveredAuthor] = useState(false);

  useEffect(() => {
    if (author?.image?.url) {
      loadOfflineImage(author.image.url).then((res) => {
        setOfflineThumbnailBlob(res);
      });
    }
  }, [author, loadOfflineImage]);

  return (
    <div>
      <div className="flex items-center py-4 font-sans">
        <Link
          href={author?.link ?? ""}
          className="flex-shrink-0"
          onMouseEnter={() => setHoveredAuthor(true)}
          onMouseLeave={() => setHoveredAuthor(false)}
        >
          <ImageWithSkeleton
            src={offlineThumbnailBlob ?? author?.image?.url ?? settings?.authorFallbackImage ?? ""}
            alt={`${author?.name} - ${author?.jobTitle}`}
            width={180}
            height={240}
            className="h-[60px] w-[45px] object-cover md:h-[120px] md:w-[90px]"
            isHovered={hoveredAuthor}
          />
        </Link>
        <div className="ml-[16px] flex w-full justify-between md:ml-[24px] md:flex-col md:justify-center">
          <div>
            <Link
              href={author?.link ?? ""}
              className={`no-underline decoration-dark-50 decoration-1 transition-all ease-in-out md:underline ${
                hoveredAuthor
                  ? "decoration-dark-50 hover:decoration-dark-50"
                  : "decoration-transparent hover:decoration-dark-50"
              }`}
              onMouseEnter={() => setHoveredAuthor(true)}
              onMouseLeave={() => setHoveredAuthor(false)}
            >
              <span className="font-condensed text-xl dark:text-white sm:text-2xl">{author?.name}</span>
              <p className="font-condensed text-sm font-light text-dark-70 dark:text-white-70 sm:text-base">
                {author?.jobTitle}
              </p>
            </Link>
          </div>
          {/*<Link
            href={author?.link!}
            className="dark:text-middle-light-turquoise font-sans text-sm sm:text-base text-blue hover:underline mt-2"
          >
            Profil
          </Link>*/}
        </div>
      </div>
      <DottedSeparator />
    </div>
  );
};
